import url from '../url'
import headers from '../headers'

export default {
	upload (context, user_uid, watch_id, file) {
		const formData = new FormData()
		formData.append('file', file)
		return context.$http.post(
			`${url}/users/${user_uid}/files/`,
			formData,
			{
				headers: {
					'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
					'Content-Type': 'multipart/form-data'
				}
			}
		)
	},
	uploadBlob (context, user_uid, watch_id, file, extension = 'webm') {
		const formData = new FormData()
		formData.append('file', file, `blob.${extension}`)
		return context.$http.post(
			`${url}/users/${user_uid}/files/`,
			formData,
			{
				headers: {
					'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
					'Content-Type': 'multipart/form-data'
				}
			}
		)
	},
	get (context, user_uid, watch_id, file_uid, acceptMedia = '*/*') {
		return context.$http.get(
			`${url}/users/${user_uid}/files/${file_uid}/`,
			{
				headers: {
					'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
					'Accept': acceptMedia
				},
				responseType: 'arraybuffer',
			}
		)
	},
	getMetadata (context, user_uid, watch_id, file_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/files/${file_uid}/metadata/`,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/files.js